var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "app-filter-good-table-container" },
            [
              _c("vue-good-table", {
                ref: "benefitSiteList",
                attrs: {
                  mode: "remote",
                  title: "Benefit Site List",
                  totalRows: _vm.totalRecords,
                  columns: _vm.columns,
                  rows: _vm.rows,
                  "pagination-options": {
                    enabled: true,
                    mode: "pages",
                    pageLabel: "Page",
                    position: "bottom",
                    perPage: _vm.serverParams.perPage,
                    perPageDropdown: [25, 50, 100, 200, 500],
                    dropdownAllowAll: false
                  },
                  selectOptions: {
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: "custom-class",
                    selectionText: "rows selected",
                    clearSelectionText: "clear"
                  },
                  "search-options": {
                    enabled: false
                  }
                },
                on: {
                  "on-page-change": _vm.onPageChange,
                  "on-selected-rows-change": _vm.selectionChanged,
                  "on-column-filter": _vm.onColumnFilter,
                  "on-per-page-change": _vm.onPerPageChange,
                  "on-sort-change": _vm.onSortChange
                },
                scopedSlots: _vm._u(
                  [
                    _vm._l(_vm.rows, function(row, key) {
                      return {
                        key: "table-row",
                        fn: function(props) {
                          return [
                            _c("div", { key: key }, [
                              props.column.field == "action"
                                ? _c(
                                    "div",
                                    { staticClass: "table-action" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "btn edit-btn-vvg waves-effect",
                                          attrs: {
                                            title: "Edit Benefit Site",
                                            to: {
                                              name: "UpdateBenefitSite",
                                              params: { id: props.row.id }
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-pencil",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          props.formattedRow[props.column.field]
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ])
                          ]
                        }
                      }
                    }),
                    {
                      key: "selected-row-actions",
                      fn: function(computed) {
                        return _c("div", {}, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(computed.selectedRows) +
                              "\n                        "
                          )
                        ])
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [
        _vm._v("Benefit Sites\n            ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-373182b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-373182b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/benefits/ListBenefitSite.vue
// module id = null
// module chunks = 